import cn from "./cn";

/**
 * PageHeader — the one page header (DESIGN.md › Layout, audit §17).
 * One h1, an optional one-line description, actions on the right on desktop
 * and below the title on phones, and an optional navigation row (RouteTabs)
 * directly underneath. No eyebrow: the topbar breadcrumb carries the module.
 */
export default function PageHeader({ title, description, actions, navigation, meta, className }) {
  return (
    <header data-ui="page-header" className={cn("flex flex-col gap-4", className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-6">
        <div className="min-w-0">
          <h1 className="text-page-title text-foreground [text-wrap:balance]">{title}</h1>
          {description ? <p className="mt-1 max-w-[90ch] text-body-sm text-secondary">{description}</p> : null}
          {meta ? <div className="mt-1 text-meta text-tertiary">{meta}</div> : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2 sm:shrink-0 sm:justify-end">{actions}</div> : null}
      </div>
      {navigation}
    </header>
  );
}
